import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { APIRequest } from '../../common/Common';
import { getAlertMessageFunction, handleRejected } from '../../common/Util';

const initialState = {
  idList: [
    {
      htmComCd: '테스트',
      htmComNm: '테스트',
      htmComId: '테스트',
    },
  ],
  step: 1,

  idInfo: {},
};

//본인인증 id 리스트 찾기
export const getHtmIdList = createAsyncThunk('findByPassword/getHtmIdList', async data => {
  const response = await APIRequest('/YA/HtmIdList', data);
  return response;
});

//본인인증 id 찾기
export const HtmIdFind = createAsyncThunk('findByPassword/HtmIdFind', async data => {
  const response = await APIRequest('/YA/HtmIdFind', data);
  return response;
});

// 문자인증 보내기
export const HtmInfoSend = createAsyncThunk('findByPassword/HtmInfoSend', async data => {
  const response = await APIRequest('/YA/HtmInfoSend', data);
  return response;
});

// 알림톡 인증 보내기
export const HtmKakaoSend = createAsyncThunk('findByPassword/HtmKakaoSend', async data => {
  const response = await APIRequest('/YA/HtmKakaoSend', data);
  return response;
});

//인증 확인
export const HtmIDFindCertify = createAsyncThunk('findByPassword/HtmIDFindCertify', async data => {
  const response = await APIRequest('/YA/HtmIDFindCertify', data);
  return response;
});

//비밀번호 변경
export const HtmPWChangeEnd = createAsyncThunk('findByPassword/HtmPWChangeEnd', async data => {
  const response = await APIRequest('/YA/HtmPWChangeEnd', data);
  return response;
});

const findByPasswordSlice = createSlice({
  name: 'findByPassword',
  initialState,
  reducers: {
    resetFindByPassword: state => {
      state = initialState;
    },
    setStep: (state, action) => {
      state.step = action.payload;
    },
    setSelectedId: (state, action) => {
      state.selectedId = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getHtmIdList.fulfilled, (state, action) => {
      const alertMessage = getAlertMessageFunction();
      const { list, Err } = action.payload;
      state.idList = list || [];
      if (!Err && list.length > 0) {
        state.step = 2;
      } else if (list.length == 0) {
        alertMessage('대상자를 찾을 수 없습니다.', 'error');
      }
    });
    builder.addCase(HtmIdFind.fulfilled, (state, action) => {
      const { resultMsg } = action.payload;
      if (!resultMsg) {
        state.idInfo = action.payload;
        state.step = 3;
      }
    });
    builder.addCase(HtmInfoSend.fulfilled, (state, action) => {
      const { Err } = action.payload;
      if (!Err) {
        state.step = 4;
      }
    });
    builder.addCase(HtmKakaoSend.fulfilled, (state, action) => {
      const { Err } = action.payload;
      if (!Err) {
        state.step = 4;
      }
    });
  },
});
export default findByPasswordSlice.reducer;
export const { setStep, resetFindByPassword } = findByPasswordSlice.actions;
